import service from "../libs/request.js";

//获取医院简介列表 这个接口线上比较慢 原因是富文本内容太多 改为以下2个接口
var getHosOverviewlist = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getDescList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getDescFirst = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getDescFirst",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};
var getDescList = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getDescList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

//获取医院简介
var getHosOverviewInfo = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getDescInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医疗联盟
var getHosOverviewUnionInfo = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getUnionInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取盛京医疗联盟列表
var getHosOverviewUnionList = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getUnionList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取第三方满意度调查
var getHosOverviewTdeeghirrtuvy = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getThirdSurvey",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取人才培养
var getHosOverviewPersonnel = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getPersonnel",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取现任领导
var getHosOverviewLeader = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getLeader",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取医院荣誉
var getHosOverviewHegnoort = function(postdata, callback) {
  service.get({
    url: "/wzHosOverview/getHonor",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getHosOverviewlist,
  getDescFirst,
  getDescList,
  getHosOverviewInfo,
  getHosOverviewUnionInfo,
  getHosOverviewUnionList,
  getHosOverviewTdeeghirrtuvy,
  getHosOverviewPersonnel,
  getHosOverviewLeader,
  getHosOverviewHegnoort,
};
